import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { Template as LoginStandalone } from "../../../templates/LoginStandaloneTemplate";
import { AccountContentTitle } from "../AccountContentTitle";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.LoginDocumentTemplate>;

export const LoginBody = (props: IProps): React.JSX.Element => {
    const { has_nav, side_nav, content_title, phone_display, phone_href } =
        props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <div className="login-standalone">
                        <LoginStandalone {...props.login_standalone} />
                    </div>
                </div>
            </div>
        </div>
    );
};
